// extracted by mini-css-extract-plugin
export default {"container":"policy-details_container__--Gjr"};